/* =============================================================================
 * FOZOCO • Cupons escondidos no carrinho (2026-11-01)
 * -----------------------------------------------------------------------------
 * Some com o chip do cupom (ex.: VALE10, SORTE10 da raspadinha) no drawer do
 * Section Store. O cupom continua valendo: só o nome não aparece no carrinho; a
 * linha "Desconto" com o valor continua. Lista em Configurações do tema > Promo
 * no carrinho > Cupons escondidos (window.FOZOCO_CART_HIDE_CODES, escrito por
 * snippets/fozoco-cart-promo.liquid). A página /cart esconde no Liquid
 * (snippets/cart-subtotal.liquid).
 * O drawer vive num shadow root aberto e é re-renderizado pelo app a cada
 * mudança, então um MutationObserver reaplica.
 * ========================================================================== */
(function () {
  "use strict";
  var CODES = (window.FOZOCO_CART_HIDE_CODES || []).map(function (c) { return String(c).trim().toUpperCase(); }).filter(Boolean);
  if (!CODES.length || window.__FOZOCO_CART_HIDE_CODES__) return;
  window.__FOZOCO_CART_HIDE_CODES__ = true;

  function hide(root) {
    var chips = root.querySelectorAll(".cart-applied-discount");
    for (var i = 0; i < chips.length; i++) {
      var t = chips[i].querySelector(".cart-applied-discount__text");
      var code = (t ? t.textContent : "").trim().toUpperCase();
      var off = CODES.indexOf(code) > -1;
      if (off && chips[i].style.display !== "none") chips[i].style.display = "none";
    }
  }

  var attempts = 0;
  (function attach() {
    var host = document.querySelector("section-store--cart-block");
    if (host && host.shadowRoot) {
      var root = host.shadowRoot;
      hide(root);
      new MutationObserver(function () { hide(root); }).observe(root, { childList: true, subtree: true });
      return;
    }
    if (++attempts > 60) return;
    setTimeout(attach, 500);
  })();
})();
